import Validations from '../../../../services/validations';

export default {
  actions: {
    Login({ dispatch }, payload) {
      return dispatch('LoginByPayload', payload)
        .then((accessToken) => {
          const expires = new Date(accessToken.created);
          expires.setSeconds(expires.getSeconds() + accessToken.ttl);
          return dispatch('Acacia/Profile/AccessToken', {
            expires,
            id: accessToken.id,
            userId: accessToken.userId,
            sysIgnoreAuthorizarion: true,
          }, { root: true })
            .then(() => accessToken);
        });
    },
    LoginByPayload({ dispatch }, payload) {
      if (Validations.email(this.login)) {
        return dispatch('LoginByEmail', {
          email: payload.email,
          password: payload.password,
        });
      }
      return dispatch('LoginByUsername', {
        username: payload.login,
        password: payload.password,
      });
    },
    LoginByEmail({ dispatch }, payload) {
      return dispatch('LoginRequest', payload)
        .catch((error) => {
          if (!error || !error.response || !error.response.status !== 401) throw error;
          return dispatch('LoginByUsername', {
            username: payload.email,
            password: payload.password,
          });
        });
    },
    LoginByUsername({ dispatch }, payload) {
      return dispatch('LoginRequest', payload);
    },
    LoginRequest({ dispatch }, payload) {
      return dispatch('Acacia/Utils/Resources/POST', {
        service: 'auth',
        model: 'Users',
        url: '/login',
        data: payload,
      }, { root: true });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/access_provider/users/login.js